import { Injectable } from '@angular/core';
import { ChatPerson } from 'common/xislivechat/models/chat-person';
import { DynamicQueryAdapterService } from 'common/dynamicquery/dynamic-query-adapter.service';
import { DynamicQueryDecoratorService } from 'common/dynamicquery/dynamic-query-decorator.service';

@Injectable({
  providedIn: 'root'
})
export class ChatPersonsService {
  constructor(private DynamicQuery: DynamicQueryAdapterService,
              private DynamicQueryDecorator: DynamicQueryDecoratorService) {
  }

  public observeByChatId(chatId) {
    if (!chatId) {
      throw new Error('Missing chatId');
    }
    const personsObs = this.DynamicQuery.getQuery('chatPersonsByChatID', { ChatID: chatId });
    return this.DynamicQueryDecorator.create(personsObs, ChatPerson.wrap);
  }
}
